/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { ProductPageService } from '@pages/ProductPage/services';

const getSrv = () => {
  return vappContainer.get<ProductPageService>(ProductPageService.displayName);
};

export const getProductPageData = async (context: any, event: any) => {
  const currentState = 'GET_PRODUCT_PAGE_DATA';
  const method = 'getProductPageData';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getProductPageData();
      if (content) {
        return resolve({
          key: 'RENDER_PRODUCT_PAGE_DATA',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'get Time not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'RENDER_PRODUCT_PAGE_DATA_ERROR',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'RENDER_PRODUCT_PAGE_DATA_ERROR',
        value: err?.message,
      });
    }
  });
};
